<template>
<div class="vue-editable"
	:class="{ editing, disabled }"
	@dblclick="startEdit"
	@keypress="onKeypress"
	@input="onInput"
	@focus="onFocus"
	@blur="onBlur"
	:data-units="spacedUnits"
/>
</template>


<script>
export default {
	name: 'uiEditable',
	props: {
		content: {
			type: [ Number, String ]
		},
		units: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isNumber: false,
			editing: false,
			prev: '',
			cur: '',
		}
	},
	mounted() {
		if (typeof this.content !== 'string') {
			this.isNumber = true
			this.prev = this.cur = this.content + ''
		} else {
			this.prev = this.cur = this.content.trim()
		}
		this.$el.innerText = this.prev
	},
	methods: {
		startEdit() {
			if (this.disabled) return
			this.$el.contentEditable = true
			this.$el.focus()
		},
		onKeypress(e) {
			if (e.keyCode === 13) {
				e.preventDefault()
				this.$el.blur()
			}
		},
		onInput(e) {
			this.cur = e.target.innerText
			this.$emit('input', e.target.innerText)
		},
		onFocus(e) {
			this.editing = true
			this.prev = (this.cur + '').trim()
			this.$emit('focused', e.target.innerText)
		},
		onBlur(e) {
			this.$el.innerText = (this.cur + '').trim()
			this.$el.contentEditable = false
			this.editing = false

			if(this.prev === this.cur.trim()) return
			this.$emit('updated', this.cur.trim())
		}
	},
	computed: {
		spacedUnits() {
			return (this.units && this.units.length)
				? ` ${this.units}`
				: ''
		}
	},
	watch: {
		content(value) {
			this.cur = value
			this.$el.innerText = value
		}
	}
}
</script>

<style lang="less" scoped>

.vue-editable {
	display: inline-block;
	outline: none;
	cursor: pointer;
	box-sizing: border-box;
	user-select: none;

	&.disabled {
		text-decoration: line-through;
		cursor: default;
		pointer-events: none;
	}

	&.editing {
		border-bottom: 1px solid transparent;
		cursor: default;
		user-select: auto;

		&:after {
			display: none;
		}
	}

	&:after {
		content: attr(data-units);
	}
}

</style>
